// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-F5B37583-0E9C-4732-9B5E-2DADD803F250 .expander-body .message-body {\n  white-space: pre-line;\n}\n", "",{"version":3,"sources":["webpack://src/common/userMainWindow/notifications/startupNotifications/startupNotifications.less"],"names":[],"mappings":"AACI;EACI,qBAAA;AAAR","sourcesContent":["#V-F5B37583-0E9C-4732-9B5E-2DADD803F250{\n    & .expander-body .message-body{\n        white-space: pre-line;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
